<template>
  <section class="mobile-menu">
    <order-file-uploader>
      <uploader-btn class="upload-btn" key="pc">
        <div class="add">
          <span></span>
          <span></span>
        </div>
        <span class="label">Toevoegen</span>
      </uploader-btn>
    </order-file-uploader>
  </section>
</template>

<script>
import OrderFileUploader from '@/components/ui/file-upload/OrderFileUploader.vue'

export default {
  components: { OrderFileUploader }
}
</script>

<style lang="scss" scoped>
.mobile-menu {
  //width: 46px;
  height: 46px;
  background: white;
  border-radius: 30px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10;
  box-shadow: rgba(0, 0, 0, 0.33) 0 0px 32px -4px;
  padding: 13px;
}

.upload-btn {
  padding: 0;
  border: none;

  .label {
    vertical-align: middle;
    text-transform: uppercase;
    font-size: 11px;
    color: var(--sub-color);
    padding-left: 5px;
  }

  .add {
    width: 21px;
    position: relative;
    height: 21px;
    display: inline-block;
    vertical-align: middle;

    span {
      background-color: var(--sub-color);
      height: 3px;
      left: 0;
      position: absolute;
      top: 9px;
      width: 21px;
      display: inline-block;
    }

    span:nth-of-type(2) {
      height: 21px;
      left: 9px;
      top: 0;
      width: 3px;
    }
  }
}
</style>
